import { Component, OnInit } from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatDialogRef } from '@angular/material/dialog';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';

@Component({
    selector: 'app-more-filter-popup',
    templateUrl: './more-filter-popup.component.html',
    styleUrls: ['./more-filter-popup.component.scss'],
    standalone: false
})
export class MoreFilterPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<MoreFilterPopupComponent>,
    public selectionService: SelectionGenericService,
    public sharedService: SharedService,
    public filterService: FilterService,
    ) {
  }

  ngOnInit(): void {
    this.subscribeExcecuteSelected();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  subscribeExcecuteSelected(): void {
    this.selectionService.excecuteMoreFilter.subscribe(() => {
      this.cancel();
    });
  }

  clearFilter(): void {
    switch (this.sharedService.selectedSelectionTabId) {
      case 1:
        this.filterService.clearEmployeeMoreFilters();
        this.selectionService.resetEmployeeMoreFilterValues();
        break;

      case 2:
        this.filterService.clearLeaveMoreFilters();
        this.selectionService.resetLeaveMoreFiltersValues();
        break;
      case 3:
        this.filterService.clearActuationMoreFilters();
        this.selectionService.resetActuationMoreFilterValues();
        break;
      case 5:
        this.filterService.clearTaskMoreFilters();
        this.selectionService.resetTaskMoreFilterValues();
        break;

      default:
        this.cancel();
        break;
    }
  }

  searchList(): void {
    switch (this.sharedService.selectedSelectionTabId) {
      case 1:
        // First Page with Fifty Records (0, 50)
        this.selectionService.SearchEmployees(0, 50, true);
        this.cancel();
        break;

      case 2:
        if(!this.filterService.LeaveSelectionMoreFilterForm.get('NoDiagnosisReason').errors?.required) {
          // First Page with Fifty Records (0, 50)
          this.selectionService.SearchLeaves(0 , 50, true);
          this.cancel();
        }
        break;

      case 3:
        // First Page with Fifty Records (0, 50)
        this.selectionService.GetActuationSelection(0 , 50, true);
        this.cancel();
        break;

      case 5:
        // First Page with Fifty Records (0, 50)
        this.selectionService.SearchTasks(0 , 50, true);
        this.cancel();
        break;

      default:
        this.cancel();
        break;
    }
  }

}
